module.exports = __webpack_public_path__ + "img/guide-meta-ai.d8d36b63.svg";